import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {FC} from 'react';
import {useGetPaymentTransactionsQuery} from '../../../../global/services/payment';
import {PaymentTransaction, TABLE_CELL_META} from './constants';
import {HistoryBodyCell, HistoryHeadCell, HistoryRoot, HistoryTable} from './styles';

export const BalanceHistory: FC = () => {
  const {data} = useGetPaymentTransactionsQuery(null);
  const operations = data?.content || [];

  return (
    <HistoryRoot>
      <TableContainer>
        <HistoryTable>
          <TableHead>
            <TableRow>
              {TABLE_CELL_META.map((item) => (
                <HistoryHeadCell key={item.id} align={item.align}>
                  {item.label}
                </HistoryHeadCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {operations.map((row: PaymentTransaction, idx: number) => (
              <TableRow key={row.invoiceId || row.invoiceNumber || idx}>
                {TABLE_CELL_META.map((item) => (
                  <HistoryBodyCell key={item.id} align={item.align}>
                    {item.render(row)}
                  </HistoryBodyCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </HistoryTable>
      </TableContainer>
    </HistoryRoot>
  );
};
